import React from "react";
import { AiFillGithub, AiOutlineMail } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

const GITHUB_URL = "https://github.com/Yuvasreepadmanaban";
const LINKEDIN_URL = "https://www.linkedin.com/in/yuvasree-padmanabhan/";
const EMAIL = "yuvasreepadmanabhan@gmail.com";

function SocialLinks({
  className = "",
  iconClassName = "icon-colour home-social-icons",
  linkStyle,
}) {
  return (
    <>
      <li className={`social-icons ${className}`}>
        <a
          href={GITHUB_URL}
          target="_blank"
          rel="noreferrer"
          className={iconClassName}
          style={linkStyle}
          aria-label="GitHub"
        >
          <AiFillGithub />
        </a>
      </li>
      <li className={`social-icons ${className}`}>
        <a
          href={LINKEDIN_URL}
          target="_blank"
          rel="noreferrer"
          className={iconClassName}
          style={linkStyle}
          aria-label="LinkedIn"
        >
          <FaLinkedinIn />
        </a>
      </li>
      <li className={`social-icons ${className}`}>
        <a
          href={`mailto:${EMAIL}`}
          className={iconClassName}
          style={linkStyle}
          aria-label="Email"
        >
          <AiOutlineMail />
        </a>
      </li>
    </>
  );
}

export default SocialLinks;
